import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { STALE_TIME } from '@/shared/api';
import { mapPlantsWithDevices } from '@/shared/data-mappers';
import type { PlantWithDevices } from '@/shared/data-types';

/**
 * 발전소 + 설비 목록 query 정의 SSOT — 알림·인버터 필터의 발전소/설비 select 용. BE = app-legacy(v3)
 * `GET /plants` (inverters·rtus 응답 기본 포함, include 불필요 — RN 앱 정합). 세션 중 거의 안 변함 →
 * `staleTime: STATIC`. mock/real 전환은 `USE_MOCK` flag. [TODO:mock]
 */
export const PLANTS_WITH_DEVICES_QUERY_KEY = ['plants', 'with-devices'] as const;

/** mock 토글 — true=mock, false=실제 v3 `plant.list`. 실연동 완료 시 flag·mock 제거. [TODO:mock] */
const USE_MOCK = false;

// mock — 알림 mock 이벤트(events.query-options)의 plantId·instanceId 와 1:1 정합.
// id 는 **숫자 문자열**(실 v3 가 Long → param `Number()` 정합, mock↔real 형태 일치). 구독은 active(게이트 통과 —
// mock 은 인버터 흐름 검증용이라 선택 가능해야 함). [TODO:mock]
const MOCK_PLANTS: PlantWithDevices[] = [
  {
    plantId: '1',
    plantName: '서울식물원주차장태양광발전소',
    rtuId: '11',
    inverters: [
      { inverterId: '101', instanceId: '1', inverterName: '인버터 01', imei: 'MOCK-RTU-11' },
      { inverterId: '102', instanceId: '2', inverterName: '인버터 02', imei: 'MOCK-RTU-11' },
      { inverterId: '104', instanceId: '4', inverterName: '인버터 04', imei: 'MOCK-RTU-11' },
    ],
    subscription: { status: 'active' },
  },
  {
    plantId: '2',
    plantName: '헤리트태양광발전소01',
    rtuId: '12',
    inverters: [
      { inverterId: '203', instanceId: '3', inverterName: '인버터 03', imei: 'MOCK-RTU-12' },
    ],
    subscription: { status: 'active' },
  },
  {
    plantId: '3',
    plantName: '판교제2태양광발전소',
    rtuId: '13',
    inverters: [
      { inverterId: '301', instanceId: '1', inverterName: '인버터 01', imei: 'MOCK-RTU-13' },
    ],
    subscription: { status: 'active' },
  },
  {
    plantId: '4',
    plantName: '세종행정타운태양광발전소',
    rtuId: '14',
    inverters: [
      { inverterId: '401', instanceId: '1', inverterName: '인버터 01', imei: 'MOCK-RTU-14' },
    ],
    subscription: { status: 'active' },
  },
];

export const plantsWithDevicesQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<PlantWithDevices[]>({
    queryKey: PLANTS_WITH_DEVICES_QUERY_KEY,
    queryFn: async ({ signal }) => {
      if (USE_MOCK) {
        await new Promise((resolve) => setTimeout(resolve, 200));
        return MOCK_PLANTS;
      }
      const raw = await api.plant.list(undefined, { signal });
      return mapPlantsWithDevices(raw);
    },
    staleTime: STALE_TIME.DEFAULT,
  });
